import { createApi } from '@reduxjs/toolkit/query/react';
import { ResponsePagingDto } from 'types';
import axiosBaseQuery from 'utils/base-api';
import {
  AchievePendingComplaintsFeedbackRequest,
  feedbackTicket,
  PendingComplaintsFeedbackRequest
} from '../../types/dto/confirrm-reflection-request';

export const confirmReflectionRequestApi = createApi({
  reducerPath: 'confirm-reflection-request',
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    getPendingComplaintsFeedback: builder.query<ResponsePagingDto<feedbackTicket>, PendingComplaintsFeedbackRequest>({
      query: (requestData) => {

        return {
          url: `/tickets/dienluc/pending_complaints_feedback`,
          method: 'get',
          params: requestData
        };
      }
    }),

    patchPendingComplaintsFeedback: builder.mutation<
      ResponsePagingDto<feedbackTicket>,
      AchievePendingComplaintsFeedbackRequest
    >({
      query: (requestData) => {
        return {
          url: `/tickets/dienluc/pending_complaints_feedback/${requestData.ticketId}`,
          method: 'patch',
          data: requestData
        };
      }
    })
  })
});

export const { useGetPendingComplaintsFeedbackQuery, usePatchPendingComplaintsFeedbackMutation } =
  confirmReflectionRequestApi;
